import { render, staticRenderFns } from "./EditSaleCounter.vue?vue&type=template&id=0b911abf"
import script from "./EditSaleCounter.vue?vue&type=script&lang=js"
export * from "./EditSaleCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports